module.exports = __webpack_public_path__ + "static/media/marker.f43acdf7.svg";